/* eslint-disable import/prefer-default-export,no-return-await */
import Geocode from 'react-geocode';
import {API_KEY} from '../data/googleMap';

Geocode.setApiKey(API_KEY);

// Enable or disable logs. Its optional.
// Geocode.enableDebug();

export const fromAddress = address => Geocode.fromAddress(address);
